import { CREATE_VORLAGE_ABSCHNITT } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useCreateVorlageAbschnitt/mutation';
import {
  Mitarbeiter_CreateVorlageAbschnittMutation,
  Mitarbeiter_CreateVorlageAbschnittMutationVariables,
} from '@/gql/graphql';
import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';

export function useCreateVorlageAbschnitt() {
  const [execute, result] = useMutation<
    Mitarbeiter_CreateVorlageAbschnittMutation,
    Mitarbeiter_CreateVorlageAbschnittMutationVariables
  >(CREATE_VORLAGE_ABSCHNITT, {
    refetchQueries: [
      'mitarbeiter_rotationsplanVorlageById',
      'mitarbeiter_rotationsplanVorlagen',
    ],
    awaitRefetchQueries: true,
  });

  const createVorlageAbschnitt = useCallback(
    (variables: Mitarbeiter_CreateVorlageAbschnittMutationVariables) => {
      return execute({ variables });
    },
    [execute],
  );

  return [createVorlageAbschnitt, result] as const;
}
